import { DefaultProgressionStrategy } from './progressions/DefaultProgressionStrategy.js';
import { JazzProgressionStrategy } from './progressions/JazzProgressionStrategy.js';
import { AmbientProgressionStrategy } from './progressions/AmbientProgressionStrategy.js';
import { BreakcoreProgressionStrategy } from './progressions/BreakcoreProgressionStrategy.js';
import { ElectronicProgressionStrategy } from './progressions/ElectronicProgressionStrategy.js';
import { LofiProgressionStrategy } from './progressions/LofiProgressionStrategy.js';
import { WorldProgressionStrategy } from './progressions/WorldProgressionStrategy.js';

export class ChordProgressionStrategyRegistry {
  constructor() {
    this.defaultStrategy = new DefaultProgressionStrategy();
    this.genreStrategies = {
      jazz: new JazzProgressionStrategy(),
      ambient: new AmbientProgressionStrategy(),
      cinematic: new AmbientProgressionStrategy(),
      breakcore: new BreakcoreProgressionStrategy(),
      electronic: new ElectronicProgressionStrategy(),
      lofi: new LofiProgressionStrategy(),
      world: new WorldProgressionStrategy(),
    };
  }

  build(ctx) {
    const strategy = this.genreStrategies[ctx.genre] || this.defaultStrategy;
    return strategy.build(ctx);
  }
}
